import React, { useState } from "react";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "../BuyConfirm/BuyConfirm.module.scss";
import { formatPrice } from "../../../../utils/utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const SellConfirm = ({
  show,
  handleClose,
  handleSellConfirm,
  sellData,
  title,
}) => {
  const spotPrice = useSelector((state) => state?.users?.spotPrice);

  // useEffect(() => {
  //   if (show) {
  //     sellData.price =
  //       sellData.tokenName === "Gold STBL"
  //         ? spotPrice?.goldPrice
  //         : spotPrice?.silverPrice;
  //   }
  // }, [spotPrice, show]);

  return (
    <>
      <Modal
        className={styles.buy_modal}
        show={show}
        handleClose={handleClose}
        title={title}
      >
        <ul>
          <li>
            <h6>Quantity (Ozt)</h6>
            <h4>{sellData.quantity}</h4>
          </li>
          <li>
            <h6>At Price</h6>
            <h4>${formatPrice(Number(sellData?.amount))}</h4>
          </li>
          <li>
            <h6>Total</h6>
            <h4>
              ${formatPrice(Number(sellData?.quantity * sellData?.amount))}
            </h4>
          </li>
        </ul>
        <Button
          fluid
          variant="yellow_btn"
          className={styles.submit_btn}
          onClick={handleSellConfirm}
        >
          Confirm Sell
        </Button>
      </Modal>
    </>
  );
};

export default SellConfirm;
